import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import HomePage from '../routes/HomePage';
import CategoryPage from '../routes/CategoryPage';
import CategoryVideoPlay from '../routes/CategoryVideoPlay';
import SubscribePage from '../routes/SubscribePage';
import LoginPage from '../routes/LoginPage';
import OtpPage from '../routes/OtpPage';
import SubscriptionProcessing from '../routes/SubscriptionProcessing';
import Auth from '../components/Auth';
import TermsPage from '../routes/TermsPage';
import MyAccountPage from '../routes/MyAccountPage';

const Routing = () => {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <SubscribePage />
        },
        {
            path: "/otp",
            element: <OtpPage />
        },
        {
            path: "/subscription-processing",
            element: <SubscriptionProcessing />,
        },
        {
            path: "/login",
            element: <LoginPage />
        },
        {
            path: "/home",
            element: <Auth>
                <HomePage />
                </Auth>
        },
        {
            path: "/category/:category_name",
            element: 
            <Auth>
                <CategoryPage />
            </Auth>
        },
        {
            path: "/category/video/play",
            element: 
            <Auth>
                <CategoryVideoPlay />
            </Auth>
        },
        {
            path:"/terms",
            element:<TermsPage />
        },
        {
            path:"/my-account",
            element:<MyAccountPage />
        },
        {
            path: "*",
            element: <Navigate to={"/"} />
        }
    ])

    return (
        <RouterProvider router={
            router
        } />
    )
}

export default Routing